import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface MedalIconProps {
  fill: string;
}

export const MedalIcon = ({ fill }: MedalIconProps) => {
  return (
    <Svg width={16} height={15} viewBox="0 0 16 15" fill="none">
      <Path
        fill={fill}
        d="M7.09766 3.83203L5.21094 0.6875C5.07422 0.441406 4.74609 0.25 4.47266 0.25H1.4375C1.08203 0.25 0.863281 0.660156 1.05469 0.960938L4.11719 5.30859C4.91016 4.54297 5.94922 4.02344 7.09766 3.83203ZM14.5352 0.25H11.5C11.1992 0.25 10.9258 0.414062 10.7617 0.6875L8.875 3.83203C10.0234 4.02344 11.0625 4.54297 11.8555 5.30859L14.918 0.960938C15.1094 0.660156 14.8906 0.25 14.5352 0.25ZM8 4.625C5.32031 4.625 3.1875 6.78516 3.1875 9.4375C3.1875 12.1172 5.32031 14.25 8 14.25C10.6523 14.25 12.8125 12.1172 12.8125 9.4375C12.8125 6.78516 10.6523 4.625 8 4.625ZM10.5156 8.94531L9.47656 9.95703L9.72266 11.3789C9.77734 11.625 9.50391 11.8164 9.25781 11.707L8 11.0234L6.71484 11.707C6.46875 11.8164 6.19531 11.625 6.25 11.3789L6.49609 9.95703L5.45703 8.94531C5.26562 8.75391 5.375 8.45312 5.62109 8.39844L7.07031 8.20703L7.69922 6.89453C7.75391 6.78516 7.86328 6.73047 7.97266 6.73047C8.10938 6.73047 8.21875 6.78516 8.27344 6.89453L8.90234 8.20703L10.3516 8.39844C10.5977 8.45312 10.707 8.75391 10.5156 8.94531Z"
      />
    </Svg>
  );
};
